import React, { useEffect, useState } from 'react'; // Import React and hooks (useEffect, useState) for state management and lifecycle.
import axios from 'axios'; // Import Axios for making HTTP requests.
import { useHistory, Link } from 'react-router-dom'; // Import useHistory for navigation and Link for routing.
import { styled } from '@mui/material/styles'; // Import styled for creating styled components with Material UI theme.
import { Flip, ToastContainer, Zoom, toast } from "react-toastify"; // Import ToastContainer, toast, and animations from react-toastify.
import "react-toastify/dist/ReactToastify.css"; // Import CSS for react-toastify.
import { useTheme } from '@mui/material/styles'; // Import useTheme hook for using Material UI theme.
import Box from '@mui/material/Box'; // Import Box component for layout.
import OutlinedInput from '@mui/material/OutlinedInput'; // Import OutlinedInput for styled inputs.
import InputLabel from '@mui/material/InputLabel'; // Import InputLabel for form control labeling.
import MenuItem from '@mui/material/MenuItem'; // Import MenuItem for dropdown items.
import FormControl from '@mui/material/FormControl'; // Import FormControl to wrap form elements.
import Select from '@mui/material/Select'; // Import Select component for dropdown selection.
import Chip from '@mui/material/Chip'; // Import Chip component for displaying selected items.
import { IoArrowBackSharp } from "react-icons/io5";
import { Card } from 'antd';

// Configuration for dropdown menu height and padding.
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

// Function to determine the styling of menu items based on their selection status.
function getStyles(names, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(names) === -1 // Check if name is selected or not.
                ? theme.typography.fontWeightRegular // If not selected, use regular font weight.
                : theme.typography.fontWeightMedium, // If selected, use medium font weight.
    };
}

export default function Task() {
    const [data, setData] = useState([]); // State to store task data fetched from the API.
    const [fData, setFData] = useState([]); // State to store filtered data based on selection.
    const history = useHistory(); // Hook to enable navigation.
    const [names, setNames] = useState([]);   // State to store unique names extracted from data.
    const theme = useTheme(); // Access theme settings using useTheme hook from Material UI.
    const [personName, setPersonName] = React.useState([]); // State to store the selected names from the dropdown.
    const [loading, setLoading] = useState(true);
    const aID = sessionStorage.getItem('aID');

    // Function to handle changes in dropdown selection.
    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        // Set the selected names, splitting comma-separated strings if needed.
        setPersonName(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    // Styled component using MUI's styled API for custom styles.
    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button, // Use typography settings for buttons.
        backgroundColor: theme.palette.background.paper, // Set background color.
        padding: theme.spacing(1), // Set padding.
        fontFamily: 'Montserrat' // Use Montserrat font.
    }));

    // Function to handle navigation to a specific route.
    const redirect = () => {
        return "/coredataegap"; // Return the path for redirection.
    };

    // Function to extract unique user emails from task data.
    const processUniques = (data) => {
        let arr = [];
        data.forEach(ob => {
            if (!arr.includes(ob.user__email)) { // Check if the email is already added.
                arr.push(ob.user__email); // Add unique emails to the array.
            }
        });
        return arr;
    };

    // Fetch task data from API on component mount.
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BE_MAIN_URL}/ocr/task/`, { // API call to get tasks.
            headers: {
                Accept: "application/json" // Set headers to accept JSON response.
            }
        })
            .then((response) => {
                if (response.status === 200) { // Check if the response is successful.
                    if (response.data.msg.length > 0) { // Check if there are any tasks.
                        console.log(response.data.msg)
                        setData(response.data.msg); // Set task data.
                        setFData(response.data.msg); // Set filtered data to show all tasks.
                        setNames(processUniques(response.data.msg)); // Extract and set unique user emails.
                        setLoading(false);
                    }
                    else if (response.data.msg.length === 0) { // If no tasks are assigned.
                        toast.info("No Task Assigned"); // Show notification.
                    }
                }
            })
            .catch((error) => { // If there is an error in the API call.
                alert("Server Error"); // Show alert.
                console.log(error); // Log the error.
            })
    }, []); // Empty dependency array means this runs only once on component mount.

    // Effect to update filtered data based on selected person names.
    useEffect(() => {
        if (personName.length === 0 && data.length > 0) { // If no names are selected, show all data.
            setFData(data);

        }
        else if (personName.length > 0) { // If there are selected names.
            const arr = [];
            personName.forEach(it => { // Iterate through selected names.
                data.forEach(ea => { // Check against each task data.
                    if (it === ea.user__email) { // If user email matches.
                        arr.push(ea); // Add task to filtered array.
                    }
                });
            });
            setFData(arr); // Update filtered data.
        }
        console.log(personName); // Log selected names.
    }, [personName]); // This effect runs whenever personName changes.

    // useEffect(() => {
    //     function handleContextMenu(e) {
    //         e.preventDefault();
    //     }
    //     const rootElement = document.getElementById('my-component');
    //     rootElement.addEventListener('contextmenu', handleContextMenu);
    //     return () => {
    //         rootElement.removeEventListener('contextmenu', handleContextMenu);
    //     };
    // }, []);

    // const handleKeyDown = (e) => {

    //     if (e.keyCode === 123) {
    //         e.preventDefault();
    //     }
    //     if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
    //         e.preventDefault();
    //     }
    //     if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
    //         e.preventDefault();
    //     }
    //     if (e.ctrlKey && e.keyCode === 85) {
    //         e.preventDefault();
    //     }
    //     if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
    //         e.preventDefault();
    //     }
    // };


    // useEffect(() => {
    //     document.addEventListener('keydown', handleKeyDown);
    //     return () => {
    //         document.removeEventListener('keydown', handleKeyDown);
    //     };
    // }, []);
    // const handleDelete = (valueToRemove) => {
    //     setPersonName((prev) => prev.filter((value) => value !== valueToRemove));
    // };

    useEffect(() => {
        if (sessionStorage.getItem('aID') && !loading) {
            console.log(parseInt(sessionStorage.getItem('aID')))
            // document.getElementById(parseInt(sessionStorage.getItem('aID')))?.scrollIntoView({ behavior: 'smooth' });
            // console.log(document.getElementById(parseInt(sessionStorage.getItem('aID'))))
            const timer = setTimeout(() => { document.getElementById(parseInt(sessionStorage.getItem('aID')))?.scrollIntoView({ behavior: 'smooth' }); }, 1000)
            return () => clearTimeout(timer)
        }
    }, [loading])


    const [redirectPath, setRedirectPath] = useState('/');

    useEffect(() => {
        const role = sessionStorage.getItem('userRole');
        console.log('User role:', role);
        let path = '/login';
        if (role === 'Admin') {
            path = '/power';
        }
        setRedirectPath(path);
    }, []);


    return (
        <div className="App" style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="absolute top-6 left-6 text-white text-3xl cursor-pointer hover:text-gray-300 transition duration-300">
                <Link to={redirectPath}>
                    <IoArrowBackSharp size={40} />
                </Link>
            </div>
            {/* Title styled with custom background, color, and typography */}
            <Div style={{ background: 'transparent', color: 'white', fontSize: 40 }} className="title text-center flex justify-center items-center font-semibold font-serif text-xl">{"PENDING TASKS"}</Div>
            {/* <Tooltip title="Logout" placement="bottom" >
                <button
                    onClick={() => {
                        sessionStorage.clear();
                        window.location.reload()
                    }}
                    className=" absolute text-white text-2xl font-semibold hover:text-orange-500 top-0 right-0 mr-4 mt-4">
                    <IoLogOut fontSize={40} />
                </button>
            </Tooltip> */}

            <div className="flex">
                {/* Form control for dropdown selection with multiple selection enabled */}
                <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel sx={{ color: 'white' }} id="demo-multiple-chip-label">Select</InputLabel>
                    <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        value={personName}
                        onChange={handleChange} // Update selected names on change.
                        input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                        renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, backgroundColor: 'transparent' }}>
                                {selected.map((value) => (
                                    <Chip key={value} label={value} sx={{ color: 'white', }} /> // Display selected names as chips.
                                ))}
                            </Box>
                        )}
                        MenuProps={MenuProps} // Use custom menu properties for dropdown.
                    >
                        {names.length > 0 && names.map((name) => ( // Iterate through names and create menu items.
                            <MenuItem
                                key={name}
                                value={name}
                                style={getStyles(name, personName, theme)} // Style items based on selection.
                            >
                                {name} {/* Display the name */}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <br />
            {/* Container to display tasks */}
            <div style={{ display: 'flex', overflow: 'auto' }} className='flex-wrap justify-center gap-4 scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-400 scrollbar-track-gray-200'>
                {fData.length > 0 && fData.map((t, index) => ( // Map through filtered data and display tasks.
                    <div className={` shadow-2xl rounded-lg p-6 w-72 gap-6 text-cyan-900 
                        ${t?.callout_count !== null && t?.callout_count > 30 ? 'bg-red-300'
                            : t?.callout_count > 0 ? 'bg-green-200'
                                : 'bg-green-100'} ${aID && parseInt(aID) === t?.id && 'border-4 border-black '}`} style={{ width: '350px' }} key={t.id} id={t.id}>
                        <div color="blue-gray" className="relative h-56 pr-2 w-80  overflow-hidden rounded-lg">
                            <img
                                src={`${t.image_urls?.[0]}`}
                                alt='Mechanical Drawing'
                                loading="lazy"
                            />
                        </div>
                        <br />
                        <div className='flex  justify-center  gap-4 grid-cols-2'>
                            <h5 className="status font-bold text-cyan-900">{index + 1}</h5> {/* Task index */}
                            <br />
                            <h6 className="status font-medium text-cyan-900">{t?.task_status}</h6> {/* Task status */}
                            <h6 className="status font-medium text-cyan-900">{t?.id}</h6> {/* Task ID */}
                        </div>
                        <br />
                        <h6 className="status font-medium shadow-md p-2 border rounded-lg flex justify-center">{t?.user__email}</h6> {/* User email */}
                        <br />
                        <button
                            id={`enter-button-${t.id}`}
                            className="bg-cyan-950 text-white font-mono font-semibold py-2 px-4 rounded-lg hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-blue-400 w-full text-center block"
                            // onClick={() => history.push({ 
                            //     pathname: redirect(),
                            //     state: `${t.id}`

                            // })}
                            onClick={() => history.push({
                                pathname: redirect(),
                                state: { taskId: t.id }  // Ensure taskId is passed as state
                            })}

                        >
                            Enter
                        </button>
                    </div>
                ))}
            </div>
            <ToastContainer /> {/* Container for displaying toast notifications */}
        </div>
    );
}
